const PlatformPage = () => null;

// eslint-disable-next-line import/no-default-export
export default PlatformPage;
